import { useEffect, useMemo, useState } from 'react'
import type { ReminderItem } from '../../../hooks/use-reminders'
import { MAX_TIMEOUT_MS, nextDueStateChange } from '../utils/due-date'

/**
 * The time to judge the reminders' due dates against: now, moved on as each one
 * comes due today and as it passes, so a list sitting on screen regroups it on its own.
 */
export function useDueClock(reminders: Array<ReminderItem>): number {
  const [tick, setTick] = useState(0)
  // Read afresh whenever the reminders change too, so an edited due date is judged against the real time.
  const now = useMemo(() => Date.now(), [reminders, tick])

  useEffect(() => {
    const nextDue = Math.min(
      ...reminders.flatMap((reminder) => {
        const next = nextDueStateChange(reminder.scheduledAt, now)
        return next != null ? [next] : []
      }),
    )
    if (!Number.isFinite(nextDue)) return
    const timer = setTimeout(() => setTick((value) => value + 1), Math.min(nextDue - now, MAX_TIMEOUT_MS))
    return () => clearTimeout(timer)
  }, [reminders, now])

  return now
}
